/* RESPONSIBLE TEAM: team-automation-foundations */
import ContentEditorRoute from 'embercom/routes/apps/app/content/edit';

export default class AutomationFinAIAgentProfilesEditRoute extends ContentEditorRoute {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.profiles.edit',
  };
}
